import React from "react";
import { Box } from "@mui/material";
import Avatar from "components/v2/common/Avatar";
import {
  changeImgTagToLink,
  formatDixaText,
  parseEscapedText,
  processSpacing,
  sanitizeTextForDixa,
  stripNumbersFromUsername,
  stripStyleFromHtml,
  testForEmail,
} from "_helpers";
import moment from "moment/moment";
import ReactHtmlParser from "react-html-parser";
import AttachmentContainer from "components/v2/common/Message/Conversation/AttachmentContainer";
import { hasAttachment } from "components/v2/common/Message/Utilities/MessageUtils";
import MoreInfo from "components/v2/common/Message/Conversation/MoreInfo";

export default function EmailContentCard({ message, msgSource }) {
  const {
    htmlBody,
    authorName,
    createdDate,
    attachments,
    authorEmail,
    recipientEmail,
    other,
    authorPhoneNumber,
    recipientPhoneNumber,
    direction,
  } = message;
  let text = changeImgTagToLink(parseEscapedText(stripStyleFromHtml(htmlBody)));

  if (sanitizeTextForDixa(_.toString(msgSource).toLowerCase())) {
    text = formatDixaText(text);
    text = processSpacing(text);
  }
  const avatarColor = direction.toUpperCase() === "INCOMING" ? "dark" : "teal";
  const containsAttachment = hasAttachment(attachments);

  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px", mb: 3 }}>
        <Box>
          <Avatar
            src={undefined}
            userName={authorName}
            alt={authorName}
            background={avatarColor}
            initialsCount={2}
            style={styles.avatar}
          />
        </Box>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Box as="p" sx={styles.userName}>
              {authorPhoneNumber ||
                (testForEmail(authorName)
                  ? "User"
                  : stripNumbersFromUsername(authorName))}
            </Box>
            {authorEmail && (
              <Box as="p" sx={styles.metaDetails}>
                {`<${authorEmail}>`}
              </Box>
            )}
          </Box>

          <Box as="p" sx={{ ...styles.metaDetails, fontSize: "12px" }}>
            {(recipientEmail || recipientPhoneNumber) && (
              <>to {`<${recipientPhoneNumber || recipientEmail}>`} • </>
            )}
            {moment(createdDate).format("MMM D h:mm a")}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          color: "#1a2b20",
          m: 0,
          fontFamily: "FustatRegular",
          fontSize: "14px",
        }}
        className="no-break-out"
      >
        {ReactHtmlParser(text || "")}
      </Box>

      {!_.isEmpty(other) && (
        <Box sx={{ marginTop: "10px" }}>
          <Box
            sx={{ ...styles.attachmentContainer, ...{ padding: "7px 12px" } }}
          >
            <MoreInfo other={other} />
          </Box>
        </Box>
      )}

      {!_.isEmpty(message) && containsAttachment && (
        <Box sx={{ marginTop: "10px" }}>
          <Box sx={{ ...styles.attachmentContainer, ...{ padding: "0 12px" } }}>
            <AttachmentContainer attachments={attachments} message={message} />
          </Box>
        </Box>
      )}
    </Box>
  );
}

const styles = {
  wrapper: {
    padding: "20px 0px",
    borderBottom: "1px solid rgb(241, 237, 230)",
  },

  userName: {
    color: "#1a2b20",
    m: 0,
    fontFamily: "FustatBold",
    fontSize: "14px",
  },
  metaDetails: {
    color: "#98a29a",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "14px",
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    fontSize: "16px",
    textTransform: "capitalize",
    borderRadius: "9999px",
  },
  attachmentContainer: {
    border: "1px solid #DCE2E3",
    borderRadius: "6px",
    padding: "15px 12px",
    lineHeight: "140%",
    fontFamily: "FustatRegular",
    fontSize: "14px",
    width: "fit-content",
    color: "#0C2728",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    backgroundColor: "#E6F3F2",
    blockquote: {
      border: "1px solid #DCE2E3",
      borderRadius: "3px",
    },
  },
};
